/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { Avatar } from '@mui/material';
import apple from '../../../assets/images/social-media/apple.svg';
import google from '../../../assets/images/social-media/google.svg';
import facebook from '../../../assets/images/social-media/facebook.svg';
import database from '../../../assets/images/database.svg';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
	iconsContainer: {
		paddingLeft: '5px',
		paddingRight: '5px',
		display: 'flex'
	}
}));
export interface Props {
	authenticationMethods: string[];
}

function SocialMediaListView(props: Props): JSX.Element {
	const { authenticationMethods } = props;
	const classes = useStyles();
	const iconsList = [];
	if (authenticationMethods.includes('USERNAME_PASSWORD')) {
		iconsList.push(<Avatar key="1" src={database} className="icon-sm" />);
	}
	if (authenticationMethods.includes('GOOGLE')) {
		iconsList.push(<Avatar key="2" src={google} className="icon-sm" />);
	}
	if (authenticationMethods.includes('FACEBOOK')) {
		iconsList.push(<Avatar key="3" src={facebook} className="icon-sm" />);
	}
	if (authenticationMethods.includes('APPLE')) {
		iconsList.push(<Avatar key="4" src={apple} className="icon-sm" />);
	}
	return <div className={classes.iconsContainer}>{iconsList}</div>;
}
export default SocialMediaListView;
